import { Alert as Alert$2 } from 'react-bootstrap';
import { Alert as Alert$1 } from './Alert.js';

const Alert = Object.assign(Alert$1, {
    Heading: Alert$2.Heading,
    Link: Alert$2.Link
});
const AlertHeading = Alert$2.Heading;
const AlertLink = Alert$2.Link;

export { Alert, AlertHeading, AlertLink };
//# sourceMappingURL=index.js.map
